import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './Page404.scss';

export function Page404() {
    return <div className="page404_wrap">
        <div className="page404_iconSection">
            <FontAwesomeIcon icon="search" />
        </div>
        <div className="page404_textSection">
            <h1 className="page404_header">
                404
            </h1>
            <p className="page404_message">
                We're sorry, the requested url wasn't found.
            </p>
        </div>
    </div>
}
